// @flow

import invariant from 'invariant';

import _ from 'lodash';

import { StepsMutuallyInclusive } from './steps-mutin';

import type { StepsOptions } from './steps-base';
import type { Step, StepId } from './step';

type GroupName = string;
type Groups = { [GroupName]: Array<StepId> };

export type StepsGroupedOptions = StepsOptions & {
	groups: Groups,
};

export class StepsMutuallyInclusiveGrouped extends StepsMutuallyInclusive {
	_groups: Groups;

	constructor (options: StepsGroupedOptions) {
		super(options);

		this._groups = options.groups;
	}

	openGroup (group: GroupName): void {
		const steps = this._getStepsInGroup(group);
		this.closeAll();
		this.openEach(steps);
	}

	getCurrentGroup (): GroupName {
		const openSteps = this._OpenSteps();
		if (openSteps.length === 0) {
			return 'allClosed';
		}
		return this._findGroupForStep(_.first(openSteps).id);
	}

	_stepSummaryClick (step: Step) {
		if (step.Locked()) {
			return;
		}

		const group = this._findGroupForStep(step.id);

		invariant(group, "A group should to be defined for every step");

		this.openGroup(group);
	}

	_findGroupForStep (id: StepId): GroupName {
		const group = _.findKey(this._groups, group => _.includes(group, id));
		return group || 'allClosed';
	}

	_getStepsInGroup (group: GroupName): Array<StepId> {
		return this._groups[group] || [];
	}
}
